module.exports = __webpack_public_path__ + "static/media/achievements-active-icon.4203a700.svg";